import React from 'react'

function MenuPage() {
  return (
    <div>MenuPage</div>
  )
}

export default MenuPage